import { useState, useEffect } from 'react';
import axios from 'axios';

let cachedBranding = null;
let isFetching = false;
let hasFetched = false;
let fetchPromise = null;

const useBranding = () => {
  const [branding, setBranding] = useState(cachedBranding);
  const [isLoaded, setIsLoaded] = useState(hasFetched);

  useEffect(() => {
    if (cachedBranding) {
      setIsLoaded(true);
      return;
    }

    if (!isFetching) {
      isFetching = true;
      fetchPromise = axios.get(`${process.env.REACT_APP_API_END_POINT}/settings`)
        .then(response => {
          if (response.data.status && response.data.data) {
            cachedBranding = response.data.data;
          } else {
            cachedBranding = {};
          }
          setBranding(cachedBranding);
          hasFetched = true;
          setIsLoaded(true);
        })
        .catch(error => {
          console.error("Error fetching branding settings:", error);
          cachedBranding = {};
          setBranding(cachedBranding);
          hasFetched = true;
          setIsLoaded(true);
        })
        .finally(() => {
          isFetching = false;
        });
    } else if (fetchPromise) {
      fetchPromise.then(() => {
        setBranding(cachedBranding);
        setIsLoaded(true);
      });
    }
  }, []);

  const transparentPixel = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

  const getUrl = (urlStr) => {
    if (!isLoaded) return transparentPixel; 
    if (urlStr) {
      if (urlStr.startsWith('http')) return urlStr;
      const base = process.env.REACT_APP_IMAGE_URL || '';
      const separator = base.endsWith('/') ? '' : '/';
      const pathPrefix = urlStr.startsWith('branding/') ? '' : 'branding/';
      return `${base}${separator}${pathPrefix}${urlStr}`;
    }
    return ""; 
  };

  return {
    logoUrl: getUrl(branding?.logo_url),
    backgroundUrl: getUrl(branding?.background_url),
    coverPicUrl: getUrl(branding?.cover_pic_url),
    isLoaded
  };
};

export default useBranding;
